import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
//@ts-ignore
import styles from './academy.module.css';
interface IAcademy {
    url: string;
    description: string;
    logo: {
        file: {
            url: string;
        }
    }
}
const useAcademyQuery = ():Array<IAcademy> => {
    const data = useStaticQuery(graphql`
    query AcademyQuery{
        allContentfulAcademy{
            nodes{
                url
          description
          logo {
                    file {
                        url
            }
          }
        }
      }
    }
    `);

    return data?.allContentfulAcademy?.nodes as Array<IAcademy>;
}
export const Academy = () => {
    const academyData = useAcademyQuery();

    return (
        <section className={styles.academySection} id="academy">
            <div className={styles.sectionTitle}>Salesbeat Academy</div>
            <div className={styles.acadCardBox}>
                {
                 academyData.map((acad, _) => {
                     return (
                         <a href={acad?.url} target="_blank" key={_} className={styles.acadCard}>
                             <div style={{height: "auto", width: 200}}>
                                 <img src={acad?.logo?.file?.url} alt=""/>
                             </div>
                            <p>{acad?.description}</p>
                         </a>
                     )
                 })   
                }
            </div>

        </section>
    )
}